<template lang="pug">
table-base.study-result-list-table(:data-role='userRole')
  //- ヘッダー部
  table-row-base.study-result-list-table__row-header.text-medium
    table-header-base.study-result-list-table__row-header__cell.align-left
      slot(name='titleHeader')
    table-header-base.study-result-list-table__row-header__cell
    //- 一時的に2つ目のボタンは教室権限のみ表示
    table-header-base.study-result-list-table__row-header__cell(v-if='isBranch')
    table-header-base.study-result-list-table__row-header__cell
  template(v-for='list in studyLists')
    //- 見出し部
    table-row-base.study-result-list-table__row-subhead.text-medium.font-bold
      table-data-base.study-result-list-table__row-subhead__cell(:colspan='4')
        .study-result-list-table__row-subhead__cell__text
          .study-result-list-table__row-subhead__cell__text__label
            slot(name='subheadYearLabel')
          .study-result-list-table__row-subhead__cell__text__value {{ list.year }}
          .study-result-list-table__row-subhead__cell__text__label
            slot(name='subheadMonthLabel')
          .study-result-list-table__row-subhead__cell__text__value {{ list.month }}
    template(v-for='group in list.groups')
      //- 一覧表示部
      table-row-base.study-result-list-table__row.text-small.font-medium
        table-data-base.study-result-list-table__row__cell
          .study-result-list-table__row__cell__text
            .study-result-list-table__row__cell__text__label
              slot(name='titleLabel')
            .study-result-list-table__row__cell__text__value {{ group.title }}
        table-data-base.study-result-list-table__row__cell
          button-primary.study-result-list-table__row__cell__button(@click='firstButtonEvent(group.managementItem)')
            slot(name='firstButtonLabel')
        //- 一時的に2つ目のボタンは教室権限のみ表示
        table-data-base.study-result-list-table__row__cell(v-if='isBranch')
          button-primary.study-result-list-table__row__cell__button(@click='secondButtonEvent(group.managementItem)')
            slot(name='secondButtonLabel')
        table-data-base.study-result-list-table__row__cell
          button-primary.study-result-list-table__row__cell__button(@click='thirdButtonEvent(group.managementItem)')
            slot(name='thirdButtonLabel')
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import TableBase from '@/components/atoms/TableBase.vue'
import TableRowBase from '@/components/atoms/TableRowBase.vue'
import TableHeaderBase from '@/components/atoms/TableHeaderBase.vue'
import TableDataBase from '@/components/atoms/TableDataBase.vue'
import ButtonPrimary from '@/components/molecules/manager/ButtonPrimary.vue'
import { StudyListType } from '@/models/studyListModel'
import { UserRoles } from '@/const/UserRoles'

/**
 * テスト一覧テーブル
 */
@Component({
  components: {
    TableBase,
    TableRowBase,
    TableHeaderBase,
    TableDataBase,
    ButtonPrimary,
  },
})
export default class StudyResultListTable extends Vue {
  // ユーザ権限
  @Prop()
  userRole!: UserRoles

  // テスト一覧表示情報
  @Prop()
  studyLists!: StudyListType[]

  // 1つ目のボタン押下時イベント
  @Prop()
  firstButtonEvent!: Function

  // 2つ目のボタン押下時イベント
  @Prop()
  secondButtonEvent!: Function

  // 3つ目のボタン押下時イベント
  @Prop()
  thirdButtonEvent!: Function

  // 教室管理者であるか
  private get isBranch(): boolean {
    return this.userRole === UserRoles.BRANCH
  }
}
</script>

<style lang="stylus" scoped>
.study-result-list-table
  width 100%

  &__row-header,
  &__row-subhead,
  &__row
    border-bottom 1px solid var(--color-manager-list__border)

  &__row-header
    background var(--color-manager-list__background)

    &__cell
      padding 10px 20px

      &:nth-child(1)
        min-width 400px

  &__row-subhead
    background var(--subhead-background)

    &__cell
      padding 10px 20px
      color var(--color-manager-list-subhead__text)

      &__text
        display flex

        &__value
          margin-right 5px

  &__row
    background var(--color-manager-list__background)
    height 55px

    &__cell
      padding 0 20px

      &__text
        display flex

      &__button
        width fit-content
        padding 10px

    &:hover
      background var(--color-manager-list__hover)

  &[data-role='academy']
    --subhead-background var(--color-manager-list-subhead-academy__background)
  &[data-role='branch']
    --subhead-background var(--color-manager-list-subhead-branch__background)
</style>
